module.exports = __webpack_public_path__ + "img/ball_1.ef9764b2.png";